import { db } from '../db'
export const setModules = ({ commit }) => {
    db.collection("modules")
        .get()
        .then(querySnapshot => {
            let modules = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_MODULES', modules);
        });

};
export const setQuestions = ({ commit }) => {
    db.collection("questions")
        .get()
        .then(querySnapshot => {
            let questions = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_QUESTIONS', questions);
        });

};
export const setChoices = ({ commit }) => {
    db.collection("choices")
        .get()
        .then(querySnapshot => {
            let choices = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_CHOICES', choices);
        });
};
export const setQuestionnaire = ({ commit }) => {
    db.collection("questionnaire")
        .get()
        .then(querySnapshot => {
            let questionnaire = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_QUESTIONNAIRE', questionnaire);
        });
};
export const setAboutUs = ({ commit }) => {
    db.collection("about-us")
        .get()
        .then(querySnapshot => {
            let aboutUs = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_ABOUT_US', aboutUs);
        });
};
export const setPrivacyPolicy = ({ commit }) => {
    db.collection("privacy-policy")
        .get()
        .then(querySnapshot => {
            let privacyPolicy = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_PRIVACY_POLICY', privacyPolicy);
        });
};
export const setSlogans = ({ commit }) => {
    db.collection("slogans")
        .get()
        .then(querySnapshot => {
            let slogans = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_SLOGANS', slogans);
        });
};
export const setAwards = ({ commit }) => {
    db.collection("awards")
        .get()
        .then(querySnapshot => {
            let awards = querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
            });
            commit('SET_AWARDS', awards);
        });
};



export const setUser = ({ commit }, user) => {
    commit('SET_USER', user)
}



